import {Flame} from 'lucide-react'

const ROWS = [
  { zone: 'Forearm / Outer Arm', pain: 'Low', speedFactor: 'Fastest sessions', priceNote: 'Baseline pricing', premium: false },
  { zone: 'Shoulder / Bicep', pain: 'Low-Medium', speedFactor: 'Fast sessions', priceNote: 'Baseline pricing', premium: false },
  { zone: 'Back (Upper)', pain: 'Medium', speedFactor: 'Standard speed', priceNote: '1.15x rate', premium: false },
  { zone: 'Chest', pain: 'Medium-High', speedFactor: 'Standard speed', priceNote: '1.15x rate', premium: false },
  { zone: 'Neck', pain: 'High', speedFactor: 'Slower, careful work', priceNote: '1.25x rate', premium: false },
  { zone: 'Ribs / Stomach', pain: 'Very High', speedFactor: 'Slow, frequent breaks', priceNote: '1.3x rate — premium zone', premium: true },
  { zone: 'Feet / Ankles', pain: 'Very High', speedFactor: 'Slow, thin skin over bone', priceNote: 'Premium surcharge zone', premium: true },
  { zone: 'Face / Scalp', pain: 'Extreme', speedFactor: 'Slowest, highest precision', priceNote: '1.3x rate — premium zone', premium: true },
]

function PainMatrix() {
  return (
    <section id="pain-matrix" className="bg-[#0e0c0a] px-4 py-20 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-5xl">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="font-serif text-3xl font-bold text-white sm:text-4xl">
            Pain & Price Matrix
          </h2>
          <p className="mt-3 text-slate-400">
            How placement sensitivity affects session speed and tattoo pricing. Ribs, feet, and face are treated as
            premium-charge zones by most studios.
          </p>
        </div>

        <div className="mt-10 overflow-x-auto rounded-2xl border border-white/10">
          <table className="w-full min-w-[640px] text-left text-sm">
            <thead>
              <tr className="border-b border-white/10 bg-white/[0.03] text-xs uppercase tracking-widest text-amber-300">
                <th scope="col" className="px-5 py-4 font-semibold">Body Zone</th>
                <th scope="col" className="px-5 py-4 font-semibold">Pain Level</th>
                <th scope="col" className="px-5 py-4 font-semibold">Session Speed</th>
                <th scope="col" className="px-5 py-4 font-semibold">Pricing Impact</th>
              </tr>
            </thead>
            <tbody>
              {ROWS.map(row => (
                <tr key={row.zone} className="border-b border-white/5 last:border-0 hover:bg-white/[0.02]">
                  <td className="px-5 py-4 font-medium text-white">
                    <span className="flex items-center gap-2">
                      {row.premium && <Flame className="h-3.5 w-3.5 text-amber-400" aria-hidden="true" />}
                      {row.zone}
                    </span>
                  </td>
                  <td className="px-5 py-4 text-slate-300">{row.pain}</td>
                  <td className="px-5 py-4 text-slate-300">{row.speedFactor}</td>
                  <td className={`px-5 py-4 ${row.premium ? 'font-semibold text-amber-300' : 'text-slate-300'}`}>
                    {row.priceNote}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  )
}

export default PainMatrix
